export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/train/front/pay-success',
      name: 'distributor-train-front-pay-success',
      component: () => import('./index.vue'),
    },
  ]
};
